var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Observable } from 'rxjs/Rx';
import { CurrentOrderService } from './../currentOrder.service';
import { TranslateService } from '@ngx-translate/core';
import { OrderService } from './../order.service';
import { FlagService } from './../../modules/features/flag.service';
import { Component } from '@angular/core';
import { OrderValidation } from '../orderValidation';
import { Injectable } from '@angular/core';
import { MixpanelService } from '../../mixpanel/mixpanel.service';
var OrderBillingComponent = (function () {
    function OrderBillingComponent(flag, orderService, translate, currentOrderService, orderValidation, mixpanelService) {
        this.flag = flag;
        this.orderService = orderService;
        this.translate = translate;
        this.currentOrderService = currentOrderService;
        this.orderValidation = orderValidation;
        this.mixpanelService = mixpanelService;
        this.isFilePOActive = false;
        this.uploadingFile = false;
        this.mixpanelService.trackEvent("billing page", null);
    }
    OrderBillingComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.currentOrderService.setMenuVisibility({
            part: true,
            address: true,
            billing: true,
            shipping: false,
            summary: false,
            completed: false
        });
        this.isFilePOActive = this.flag.isFilePOActive();
        this.currentOrderService.order.subscribe(function (order) { return _this.order = order; });
    };
    OrderBillingComponent.prototype.getPurchaseOrderNumberFieldsClass = function () {
        return this.orderValidation.getPurchaseOrderNumberFieldsClass();
    };
    OrderBillingComponent.prototype.checkField = function (event) {
        if (event.target.parentElement.className.match(/(?:^|\s)has-error(?!\S)/))
            event.target.parentElement.className = event.target.parentElement.className.replace(/(?:^|\s)has-error(?!\S)/g, '');
        if (event.target.value == '') {
            event.target.parentElement.className += " has-error";
        }
    };
    OrderBillingComponent.prototype.isValid = function () {
        return this.orderValidation.isBillingValid();
    };
    OrderBillingComponent.prototype.resetForm = function () {
        this.order.PurchaseOrderNumber = "";
        this.order.PromoCode = "";
        this.order.QuestionComment = "";
    };
    OrderBillingComponent.prototype.attachFile = function (event) {
        var _this = this;
        if (this.isFilePOActive) {
            this.uploadingFile = true;
            var fileList = event.target.files;
            if (fileList.length > 0) {
                var file_1 = fileList[0];
                this.orderService.uploadFile(file_1)
                    .then(function (result) {
                    _this.order.POfileKey = result.key;
                    _this.order.POfileURL = result.url + '/' + result.key;
                    _this.order.POfileName = file_1.name;
                    _this.order.POfile = null;
                    console.log('upload succedded ' + result);
                    _this.uploadingFile = false;
                })
                    .catch(function (error) {
                    console.log('Error uploading file : ' + error);
                    if (error != "file type not allowed")
                        error = "An error occured while submitting your file. Please try again.";
                    var title = _this.translate.get('Error');
                    var text = _this.translate.get(error);
                    Observable.forkJoin(title, text).subscribe(function (res) {
                        swal({
                            title: res[0],
                            text: res[1],
                            type: 'warning',
                            showCancelButton: false,
                            confirmButtonText: 'OK'
                        });
                    });
                    _this.order.POfile = null;
                    _this.uploadingFile = false;
                });
            }
        }
    };
    OrderBillingComponent = __decorate([
        Component({
            selector: 'cx-orderbilling',
            templateUrl: './orderbilling.component.html',
        }),
        __metadata("design:paramtypes", [FlagService,
            OrderService,
            TranslateService,
            CurrentOrderService,
            OrderValidation,
            MixpanelService])
    ], OrderBillingComponent);
    return OrderBillingComponent;
}());
export { OrderBillingComponent };
var OrderBillingGuard = (function () {
    function OrderBillingGuard(orderValidation) {
        this.orderValidation = orderValidation;
    }
    OrderBillingGuard.prototype.canActivate = function () {
        return this.orderValidation.isAddressValid();
    };
    OrderBillingGuard = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [OrderValidation])
    ], OrderBillingGuard);
    return OrderBillingGuard;
}());
export { OrderBillingGuard };
//# sourceMappingURL=orderbilling.component.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/order/wizard/orderbilling.component.js
// module id = 191
// module chunks = 0